import * as React from "react";
const IconHarddrive = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M48.2 2.3H15.8c-3.3 0-6 2.7-6 6v47.4c0 3.3 2.7 6 6 6h32.5c3.3 0 6-2.7 6-6V8.3c0-3.3-2.7-6-6.1-6m1.6 53.4c0 .9-.7 1.5-1.5 1.5H15.8c-.9 0-1.5-.7-1.5-1.5V8.3c0-.9.7-1.5 1.5-1.5h32.5c.9 0 1.5.7 1.5 1.5z" />
    <path d="M43.6 32c0-6.3-5.2-11.5-11.5-11.5S20.6 25.7 20.6 32c0 2.3.7 4.5 1.9 6.3-1.9 1.3-3.7 2.7-4.4 4-2.1 3.6-.9 8.2 2.7 10.3 1.2.7 2.5 1 3.8 1 .6 0 1.3-.1 1.9-.3 1.9-.5 3.6-1.8 4.6-3.5.8-1.3 1.1-3.8 1.3-6.4 6.2-.1 11.2-5.2 11.2-11.4M27.2 47.6c-.4.7-1.1 1.2-1.8 1.4-.8.2-1.6.1-2.3-.3s-1.2-1.1-1.4-1.8-.1-1.6.3-2.3c.5-.9 3.1-2.7 6.1-4.4-.1 3.4-.4 6.6-.9 7.4m5.3-8.6c0-1.1 0-2.1-.1-2.7 0-.8-.5-1.5-1.1-1.9-.7-.4-1.5-.4-2.2-.1-.6.3-1.7.9-2.9 1.6-.8-1.2-1.2-2.5-1.2-4 0-3.9 3.1-7 7-7s7 3.1 7 7c.1 3.8-2.8 6.8-6.5 7.1M42.8 50.3c-.4.4-.7 1-.7 1.6s.2 1.2.7 1.6c.4.4 1 .7 1.6.7h.4c.1 0 .3-.1.4-.1.1-.1.3-.1.4-.2l.3-.3c.4-.4.7-1 .7-1.6s-.2-1.2-.7-1.6c-.8-.9-2.3-.9-3.1-.1" />
  </svg>
);
export default IconHarddrive;
